import sgImgS1 from '../images/gallery/seminar.webp'
import sgImgS2 from '../images/gallery/student.webp'
import sgImgS3 from '../images/gallery/tedx.webp'

import brImgS1 from '../images/gallery/award.webp'
import brImgS2 from '../images/gallery/international.webp'
import brImgS3 from '../images/gallery/univ.webp'

import uxImgS1 from '../images/gallery/univ.webp'
import uxImgS2 from '../images/gallery/student.webp'
import uxImgS3 from '../images/gallery/international.webp'

const Services = [
    {
        Id: '1',
        sImgS: sgImgS1,
        sTitle: 'Invite Asslam Shaikh',
        subtitle: 'Guest of Honor & Speaker for Schools, Colleges & Educational Events',
        description: 'Looking for an engaging speaker who can inspire students to think globally and make informed career decisions?',
        features: [
            'Career Guidance Seminars',
            'Study Abroad Awareness Sessions',
            'Educational Conferences',
            'School & College Events',
            'Youth Leadership Programs',
        ],
        cta: 'Invite as Speaker',
        icon: 'flaticon-promotion',
        ssImg1: sgImgS2,
        ssImg2: sgImgS3,
    },
    {
        Id: '2',
        sImgS: brImgS1,
        sTitle: 'For Edupreneurs',
        subtitle: 'Start Your Own Study Abroad Business',
        description: 'The international education industry is growing rapidly, and there has never been a better time to enter the sector.',
        features: [
            'Launch your own study abroad venture',
            'Access proven business systems',
            'Receive expert mentorship',
            'Partner with an established global brand',
            'Build a meaningful and profitable business',
        ],
        cta: 'Become an Edupreneur',
        icon: 'flaticon-self-growth',
        ssImg1: brImgS2,
        ssImg2: brImgS3,
    },
    {
        Id: '3',
        sImgS: uxImgS1,
        sTitle: 'For University Partners',
        subtitle: 'Expand Your Reach in India',
        description: 'India is one of the world\'s largest and fastest-growing student markets.',
        features: [
            'Increase student recruitment',
            'Build brand visibility',
            'Conduct market-entry activities',
            'Host recruitment events',
            'Strengthen institutional partnerships',
        ],
        cta: 'Explore Partnership Opportunities',
        icon: 'flaticon-verified',
        ssImg1: uxImgS2,
        ssImg2: uxImgS3,
    },
]

export default Services;
